exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recommendation{color:#333;display:flex;margin-bottom:25px}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .recommendation{color:#ccc}}:root[data-theme=dark] .recommendation{color:#ccc}.recommendation__avatar{width:60px}.recommendation__person{width:100%}.recommendation__person__heading{font-size:1.143em;font-weight:700;margin-bottom:4px;margin-top:-1px}.recommendation__person__title{color:#a1a1a1;margin-bottom:10px}.recommendation__person__comment{font-size:13.712px;font-size:0.857rem;line-height:1.6}\n", ""]);

// exports
exports.locals = {
	"recommendation": "recommendation",
	"recommendation__avatar": "recommendation__avatar",
	"recommendation__person": "recommendation__person",
	"recommendation__person__heading": "recommendation__person__heading",
	"recommendation__person__title": "recommendation__person__title",
	"recommendation__person__comment": "recommendation__person__comment"
};